/* istanbul ignore file */
import {Global} from '@emotion/core';
import React from 'react';

import {useWolfTheme} from '@br/mg-components';

const GlobalStyles = () => {
    const theme = useWolfTheme();

    return (
        <Global
            styles={{
                main: {
                    backgroundColor: theme.palette.background.default,
                    color: theme.palette.foreground.default,
                },
            }}
        />
    );
};

export default GlobalStyles;
